import { useAppSelector } from 'store/store-hooks';
import { AspectRatio } from 'services/clip.service';

import { usePanZoomSetter } from '../_pan-zoom.provider';
import { PAN_ZOOM_FE, ZOOM_STEP } from '../_pan-zoom.params';
import { usePanZoomStep } from '../_use-pan-zoom-step';
import { usePanZoomWheel } from '../_use-pan-zoom-wheel';
import { usePanZoomAr } from '../_use-pan-zoom-ar';

export const usePanZoomCb = () => {
  const os = useAppSelector((state) => state.app.os);
  const setPanZoomRotate = usePanZoomSetter();
  const getStep = usePanZoomStep(os);
  const onZoom = usePanZoomWheel();
  const onAR = usePanZoomAr();

  const onZoomDelta = (e: React.WheelEvent) => {
    const res = onZoom(getStep(e));
    if (res) setPanZoomRotate(res);
  };

  const onZoomStep = (decrease = false) => {
    const res = onZoom(decrease ? -ZOOM_STEP : ZOOM_STEP);
    if (res) setPanZoomRotate(res);
  };

  const onAspectRatio = (aspectRatio: AspectRatio) => {
    onAR(aspectRatio);
  };

  const handleReset = () => {
    setPanZoomRotate({ ...PAN_ZOOM_FE });
  };

  return {
    onAspectRatio,
    onZoomDelta,
    onZoomStep,
    handleReset,
  };
};
